import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlIconModule } from '@app/icon-library/lib/pl-icon.module';
import { SharedModule } from '@shared/shared.module';
import { FormsModule } from '@angular/forms';
import { PlCheckboxComponent } from '@app/components/pl-checkbox/pl-checkbox.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { ButtonModule } from '@app/components/button/button.module';
import { IconCustomControlModule } from '@app/components/icon-custom-control/icon-custom-control.module';
import { CheckboxItemModule } from '@app/components/pl-checkbox/checkboxItem/checkboxItem.module';
import { PlSlicePipeModule } from '@shared/pipes/plSlice/plSlice.pipe.module';

@NgModule({
  imports: [
    CommonModule,
    PlIconModule,
    SharedModule,
    FormsModule,
    MatExpansionModule,
    ButtonModule,
    IconCustomControlModule,
    CheckboxItemModule,
    PlSlicePipeModule,
  ],
  declarations: [PlCheckboxComponent],
  exports: [PlCheckboxComponent],
})
export class PlCheckboxModule {}
